import { UOM } from "models";

const LIST_ALLOW_DECIMAL_UOMS = [UOM.kilogram, UOM.allowDecimal];

export default {
  LIST_ALLOW_DECIMAL_UOMS,
};
